import React from 'react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import './party-form.css';

export function PartyField({ id, label, value, onChange, multiline = false, ...props }) {
  const Control = multiline ? 'textarea' : Input;
  return <div className="party-form__field">
    <Label htmlFor={id}>{label}{props.required ? ' *' : ''}</Label>
    <Control id={id} value={value ?? ''} onChange={event => onChange(event.target.value)} {...props} />
  </div>;
}

export function PartySelect({ id, label, value, onChange, options, placeholder, disabled }) {
  const values = value && !options.includes(value) ? [value, ...options] : options;
  return <div className="party-form__field">
    <Label htmlFor={id}>{label}</Label>
    <Select value={value || ''} onValueChange={next => { if (next) onChange(next); }} disabled={disabled}>
      <SelectTrigger id={id}><SelectValue placeholder={placeholder || 'Seleziona...'} /></SelectTrigger>
      <SelectContent>{values.map(option => <SelectItem key={option} value={option}>{option}</SelectItem>)}</SelectContent>
    </Select>
  </div>;
}

export function PartyFormSection({ title, children }) {
  return <section className="party-form__section" aria-label={title}>
    <h3 className="party-form__section-title">{title}</h3>
    {children}
  </section>;
}

export const PARTY_LEGAL_FORMS = ['S.r.l.', 'S.p.A.', 'S.a.s.', 'S.n.c.', 'Ditta Individuale', 'Cooperativa', 'Altro'];
